module.exports = __webpack_public_path__ + "img/Pelican_LogoB.png";